module.exports = __webpack_public_path__ + "static/media/09.a4ca3a43.jpg";